import * as tslib_1 from "tslib";
import { settings } from '../../settings';
import FormDataToQueryMapper from '../mapper/FormDataToQueryMapper';
import { MergeExcludeItem, SearchMaskGroupType, ProductQueryParam, SearchMaskInputType } from '../../globalTypes';
import UserQueryCreator from './UserQueryCreator';
import { ProductTypeHelper } from '../../util/ProductTypeHelper';
import { isToday } from 'date-fns';
var QueryCreator = /** @class */ (function () {
    function QueryCreator() {
    }
    QueryCreator.create = function (lturState, searchMaskGroupType, mergeExcludeList, optionalQueries, resetHiddenFilters) {
        if (searchMaskGroupType === void 0) { searchMaskGroupType = SearchMaskGroupType.PACKAGE; }
        if (mergeExcludeList === void 0) { mergeExcludeList = [MergeExcludeItem.LOCATION_PRODUCT_QUERY]; }
        if (optionalQueries === void 0) { optionalQueries = null; }
        if (resetHiddenFilters === void 0) { resetHiddenFilters = false; }
        if (!lturState) {
            return settings.defaultQuery;
        }
        var coreState = lturState.coreState;
        var websiteState = lturState.websiteState;
        var baseQuery = {};
        if (lturState.websiteState && lturState.websiteState.app && lturState.websiteState.app.url) {
            var hotelCode = lturState.websiteState.app.url.hotelCode;
            if (hotelCode) {
                baseQuery.HOTEL_CODES = [hotelCode];
            }
            var productGroup = lturState.websiteState.app.url.productGroupId;
            if (productGroup) {
                baseQuery.PRODUCT_GROUPS = [productGroup];
            }
        }
        var coreStateGroup = ProductTypeHelper.mapSearchMaskGroupTypeToCoreStateGroup(searchMaskGroupType);
        var query = tslib_1.__assign({ TRAVELLERS_ADULTS: 2 }, ((!mergeExcludeList || !mergeExcludeList.includes(MergeExcludeItem.DEFAULT_QUERY))
            && tslib_1.__assign({}, settings.defaultQuery)), ((!mergeExcludeList || !mergeExcludeList.includes(MergeExcludeItem.FORM_DATA))
            && coreState
            && coreState[coreStateGroup].formData
            && tslib_1.__assign({}, FormDataToQueryMapper.map(coreState[coreStateGroup].formData))), ((!mergeExcludeList || !mergeExcludeList.includes(MergeExcludeItem.LOCATION_PRODUCT_QUERY))
            && websiteState
            && websiteState.app.url.productQuery
            && tslib_1.__assign({}, websiteState.app.url.productQuery)), ((!mergeExcludeList || !mergeExcludeList.includes(MergeExcludeItem.USER_INPUT_QUERY))
            && websiteState
            && websiteState.searchMask
            && tslib_1.__assign({}, UserQueryCreator.create(lturState, searchMaskGroupType, optionalQueries))), baseQuery);
        if (resetHiddenFilters) {
            delete query.TRAVEL_PERIOD_DEPARTURE_DAYS;
        }
        return query;
    };
    QueryCreator.createOverrides = function (lturState, searchMaskGroupType) {
        if (searchMaskGroupType === void 0) { searchMaskGroupType = SearchMaskGroupType.PACKAGE; }
        var overrideQuery = {};
        var searchParams = new URLSearchParams(location.search);
        if (lturState
            && lturState.optimizelyState
            && !!lturState.optimizelyState.tourOperatorCodes
            && (!searchParams.has('tourOperatorCodes')
                || searchParams.get('tourOperatorCodes') === '')) {
            overrideQuery[ProductQueryParam.TOUR_OPERATOR_CODES] = lturState.optimizelyState.tourOperatorCodes.split(',');
        }
        if (lturState
            && lturState.websiteState
            && lturState.websiteState.searchMask.searchMaskBundle
            && lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType]) {
            var inputGroup = lturState.websiteState.searchMask.searchMaskBundle.groups[searchMaskGroupType];
            if (inputGroup) {
                // Override tour operator codes when flex is enabled
                var flexInput = inputGroup.inputs[SearchMaskInputType.FLEX];
                if (flexInput && flexInput.confirmedValue && flexInput.confirmedValue.value) {
                    overrideQuery[ProductQueryParam.TOUR_OPERATOR_CODES] = ['TUID', 'NPTU', 'ATID'];
                }
                // Override return date for exact departure date
                var travelPeriod = inputGroup.inputs[SearchMaskInputType.TRAVEL_PERIOD];
                if (travelPeriod && travelPeriod.confirmedValue && travelPeriod.confirmedValue.value
                    && travelPeriod.confirmedValue.value.exactDepartureDate) {
                    overrideQuery[ProductQueryParam.TRAVEL_PERIOD_RETURN_DATE] = null;
                    // Set only TUR3U if departure is today (ULM)
                    if (travelPeriod.confirmedValue.value.departureDate
                        && isToday(travelPeriod.confirmedValue.value.departureDate)) {
                        overrideQuery[ProductQueryParam.TOUR_OPERATOR_CODES] = ['TUR3U'];
                    }
                }
            }
        }
        return overrideQuery;
    };
    return QueryCreator;
}());
export { QueryCreator };
export default QueryCreator;
